import styled from 'styled-components';

export const RedeemCouponFormWrapper = styled.div`
  margin-top: auto;
`;

export const RedeemCouponFormText = styled.div`
  margin-bottom: 15px;
`;

export const AppsumoHigherPlanMessage = styled.div`
  margin-top: auto;
`;
